// File: Stockinfo_TablesContent.jsx


import React, { useEffect } from 'react';
import { Table } from 'antd';
import { Tooltip } from '@mui/material';
import SimpleExternalLinkNewWindow from '../functions/LinkFlex';
import Institutional_trend_mapping from '../functions/Institutional_trend_mapping';
import { useSelector } from 'react-redux';


const transpose = (matrix) => {
  return matrix[0].map((_, colIndex) => matrix.map((row) => row[colIndex]));
};

const Stockinfo_TablesContent = ({ tablesData, tickerValue, DD_dataset_json, DP_dataset_json, metadata, handleValueClick }) => {
  
  const vectorInstitutionalTrend = useSelector((state) => state.portfolio?.data?.Vector_institutional_trend);

    // console.log("tablesdata in jsx", tablesData)

    // console.log("DP_dataset_json ", DP_dataset_json)
    // console.log("DD_dataset_json ", DD_dataset_json)
   

    useEffect(() => {
  if (tablesData && Array.isArray(tablesData)) {
    // Identify tables dynamically
    const baseTable = tablesData.find(
      (table) => table.data[0].some((field) => !field.endsWith("_trend"))
    );
    const trendTable = tablesData.find(
      (table) => table.data[0].every((field) => field.endsWith("_trend"))
    );

    if (!baseTable || !trendTable) {
      console.warn("Base or trend table not found");
      return;
    }

    const baseFields = baseTable.data[0]; // Fields from the base table
    const trendFields = trendTable.data[0]; // Fields from the trend table

    // Map trend fields to base fields
    const mappedFields = trendFields.reduce((acc, trendField) => {
      const baseField = trendField.replace("_trend", ""); // Remove '_trend' suffix
      if (baseFields.includes(baseField)) {
        acc[trendField] = baseField; // Map 'xx_trend' -> 'xx'
      }
      return acc;
    }, {});

    // console.log("Mapped trend fields:", mappedFields);
  }
}, [tablesData]);

    
    

    const prepareTableData = (data, tickerValue, DD_dataset_json, DP_dataset_json) => {

    if (!data) {
      return { dataSource: [] };
    }

    const transposedData = transpose(data);
    // console.log("transposedData:", transposedData.map(row => row[0]));


    const findLatestTrendForField = (tickerValue, field, DD_dataset_json) => {
      if (!Array.isArray(DD_dataset_json)) {
        console.log("no DD_dataset_json");
        return null;
      }

      const normalizedField = field.replace(/\s+/g, '_').toLowerCase();

      const matchingEntries = DD_dataset_json.filter(
        (entry) => entry.ticker === tickerValue && entry.datafield.toLowerCase() === normalizedField
      );

      const sortedEntries = matchingEntries.sort((a, b) => b.epoch - a.epoch);

      return sortedEntries.length > 0
        ? {
            trend: sortedEntries[0].trend,
            oldvalue: sortedEntries[0].oldvalue,
          }
        : null;
    };

    const getLabelForField = (field, DP_dataset_json) => {
      if (!DP_dataset_json || !Array.isArray(DP_dataset_json)) {
        return field; // Return the original field if DP_dataset_json is not available
      }

      const normalizedField = field.replace(/\s+/g, '_').toLowerCase();
      const entry = DP_dataset_json.find((e) => e.DataField.toLowerCase() === normalizedField);

      return entry ? entry.Label : field; // Return the label if found, otherwise return the original field
    };

    const dataSource = transposedData
      .map((row, index) => {
        const field = row[0].replace(/_/g, ' ');
        const label = getLabelForField(row[0], DP_dataset_json);
        let value = null;
        let trend = findLatestTrendForField(tickerValue, field, DD_dataset_json);
        let epoch = null;

        

        if (row[1] && Array.isArray(row[1])) {
          value = (row[1][0] !== undefined && row[1][0] !== null) ? row[1][0].toString().replace(/_/g, ' ') : null;
          epoch = row[1][1];
        } else {
          value = (row[1] !== undefined && row[1] !== null) ? row[1].toString().replace(/_/g, ' ') : null;
        }

        // >>> Add this block <<<
        if (row[0] === 'sector') {
          const debugValue = (row[1] && Array.isArray(row[1]) && row[1][0] !== undefined) ? row[1][0] : row[1];
          // console.log("Sector field value:", debugValue);
        }
        if (row[0] === 'Country') {
          const debugValue = (row[1] && Array.isArray(row[1]) && row[1][0] !== undefined) ? row[1][0] : row[1];
          // console.log("Sector field value:", debugValue);
        }

        if (
  row[0].toLowerCase() === 'likely_institutional_exit' &&
  (!value || String(value).trim() === '0' || parseFloat(value) === 0)
) {
  return null;
}


        // Determine base tooltip text
        let fieldMetadata = null;
        const normalizedField = row[0].replace(/\s+/g, '_').toLowerCase();
        for (let key in metadata) {
          if (key.toLowerCase() === normalizedField) {
            fieldMetadata = metadata[key];
            break;
          }
        }
        let tooltipText = fieldMetadata ? `${fieldMetadata.tooltip}${trend ? `. Previous value: ${trend.oldvalue}` : ''}` : '';

        // Find Country row value once
        const countryRow = transposedData.find(r => r[0] === 'Country');
        const countryRowValue = countryRow && countryRow[1]
          ? (Array.isArray(countryRow[1]) ? countryRow[1][0] : countryRow[1])
          : null;

//           console.log("Row[0]:", row[0]);
// console.log("Country:", countryRowValue);
// console.log("Value:", value);


        return {
          key: index,
          field: label,
          originalField: row[0],
          value: value,
          trend: trend,
          epoch: epoch,
          colorOverride: (row[0] === 'sector' && countryRowValue)
            ? Institutional_trend_mapping(countryRowValue, value, tooltipText, vectorInstitutionalTrend).color
            : null,
          tooltipText: (row[0] === 'sector' && countryRowValue)
            ? Institutional_trend_mapping(countryRowValue, value, tooltipText, vectorInstitutionalTrend).tooltip
            : tooltipText,
        };
        
       
      })
      .filter((item) => item !== null);



    return { dataSource };
  };

 

  const formatDate = (epoch) => {
    if (epoch === null) {
      return <span style={{ color: 'red', fontSize: '6px' }}>?</span>;
    }

    const epochDate = new Date(epoch * 1000);
    const currentDate = new Date();
    const oneDayInMs = 86400000;

    if (currentDate - epochDate > oneDayInMs) {
      const formattedDate = epochDate
        .toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: '2-digit',
        })
        .replace(/ /g, '');
      return <span style={{ color: 'red', fontSize: '6px' }}>{formattedDate.toLowerCase()}</span>;
    }

    return null;
  };

  return (
    <div className="tables-container">

{tablesData &&
  tablesData
    .filter((table) => !table.table_name.toLowerCase().includes('funda')) // Exclude tables with 'funda'
    .sort((a, b) => {
      const isFundaA = a.table_name.toLowerCase().includes('funda');
      const isFundaB = b.table_name.toLowerCase().includes('funda');
      return isFundaA === isFundaB ? 0 : isFundaA ? -1 : 1;
    })
    .map((tableData, index) => {

      const { dataSource } = prepareTableData(tableData.data, tickerValue, DD_dataset_json, DP_dataset_json);

   
      const columns = [
        {
          title: 'Field',
          dataIndex: 'field',
          key: 'field',
        },
        {
          title: 'Value',
          dataIndex: 'value',
          key: 'value',
          render: (value, record) => {
  const fieldName = record.originalField.replace(/\s+/g, '_').toLowerCase();

  const dpEntry = DP_dataset_json?.find(
  (e) => e.DataField?.toLowerCase() === fieldName
);
const metadataEntry = Object.entries(metadata).find(
  ([key]) => key.toLowerCase() === fieldName
)?.[1];


  // if (record.originalField.toLowerCase() === 'finviz_rating') {
  //   console.log("🔍 DEBUG — Finviz_Rating match:");
  //   console.log("record.originalField:", record.originalField);
  //   console.log("fieldName (normalized):", fieldName);
  //   console.log("metadataEntry:", metadataEntry);
  //   console.log("value (raw):", value);
  // }

  const dateComponent = formatDate(record.epoch);

  const trendComponent = record.trend ? (
    record.trend.trend === 'positive' ? (
      <span style={{ color: 'green' }}> ↑</span>
    ) : record.trend.trend === 'negative' ? (
      <span style={{ color: 'red' }}> ↓</span>
    ) : null
  ) : null;

  const valueColor = record.trend
    ? record.trend.trend === 'positive'
      ? 'green'
      : record.trend.trend === 'negative'
      ? 'red'
      : 'inherit'
    : 'inherit';

  const tooltipText = record.tooltipText;
  const overrideColor = record.colorOverride;

  // === Classification based on DP_dataset_json threshold logic ===
  let underlineStyle = {};
  const cleanedValue = typeof value === 'string'
  ? value.replace('%', '').replace(/\s/g, '').replace(',', '.')
  : value;

const numVal = parseFloat(cleanedValue);

  // const numVal = parseFloat(value);
  const green = parseFloat(dpEntry?.Green);
const red = parseFloat(dpEntry?.Red);
const positive = parseFloat(dpEntry?.Positive);
const negative = parseFloat(dpEntry?.Negative);


  // if (record.originalField.toLowerCase() === 'finviz_rating') {
  //   console.log("parsed numVal:", numVal);
  //   console.log("Green threshold:", green);
  //   console.log("Red threshold:", red);
  //   console.log("Positive direction:", positive);
  //   console.log("Negative direction:", negative);
  // }

  if (!isNaN(numVal) && !isNaN(positive) && !isNaN(negative)) {
    const isHigherBetter = positive > negative;

    if (!isNaN(green)) {
      if ((isHigherBetter && numVal >= green) || (!isHigherBetter && numVal <= green)) {
        underlineStyle = { borderBottom: '2px dotted green' };
        // if (record.originalField.toLowerCase() === 'finviz_rating') {
        //   console.log("✅ Underline set: GREEN");
        // }
      }
    }

    if (!isNaN(red)) {
      if ((isHigherBetter && numVal <= red) || (!isHigherBetter && numVal >= red)) {
        underlineStyle = { borderBottom: '2px dotted red' };
        // if (record.originalField.toLowerCase() === 'finviz_rating') {
        //   console.log("❌ Underline set: RED");
        // }
      }
    }
  }

  // === Formatting Value ===
  let formattedValue;
  if (record.originalField === 'Likely_Institutional_Exit' && value === '1') {
    formattedValue = <span style={{ color: 'red' }}>TRUE</span>;
  } else if (record.originalField === 'Likely_Institutional_Entry' && value === '1') {
    formattedValue = <span style={{ color: 'green' }}>TRUE</span>;
  } else {
    formattedValue = isNaN(value) || value === null 
      ? value 
      : Number.isInteger(Number(value)) 
        ? value 
        : parseFloat(value).toFixed(2);
  }

  return (
    <Tooltip 
      title={
        <div className="tooltip-content">
          <strong>{record.field}</strong>
          <div className="neutral">{tooltipText}</div>
          {record.trend && (
            <div>
              Trend: <span className={record.trend.trend === 'positive' ? 'trend-positive' : 'trend-negative'}>
                {record.trend.trend} (was {record.trend.oldvalue})
              </span>
            </div>
          )}
        </div>
      } 
      arrow 
      placement="top"
    >
      <div style={{ position: 'relative', color: overrideColor || valueColor }}>
        <SimpleExternalLinkNewWindow
          clickedValue={
            <span style={underlineStyle}>
              {formattedValue}
            </span>
          }
          onClick={() => handleValueClick(record)}
        />
        {trendComponent}
      </div>
    </Tooltip>
  );
}



        }
      ];
      

          return (
            <div key={index} className="table-wrapper">
  <h3>{tableData.table_name.replace(/_/g, ' ')}</h3>
  <Table
    columns={columns}
    dataSource={dataSource}
    pagination={false}
    bordered
    size="small"
    showHeader={false}
    onRow={(record) => ({
      onClick: () => {
        handleValueClick(record);
      },
    })}
  />
</div>

          );
        })}
    </div>
  );
};

export default Stockinfo_TablesContent;
